import React from 'react';
import { Card, Skeleton } from 'antd';

interface ConfigType {
  initProp: string;
  rows: number;
  fullWidth?: boolean;
}

export const SkeletonHOC =
  ({ initProp, rows, fullWidth = false }: ConfigType) =>
  (WrappedComponent: any) =>
  (props: any) =>
    (
      <>
        {props[initProp] ? (
          <WrappedComponent {...props} />
        ) : (
          <Card className={fullWidth ? 'w-100' : ''}>
            <Skeleton paragraph={{ rows }} active />
          </Card>
        )}
      </>
    );
